<h2 mat-dialog-title>Converter para inteiro</h2>
<mat-dialog-content>
    A constante possui casas decimais. Escolha como o valor deve ser convertido.
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="dialogRef.close()">Cancelar</button>
    <button mat-stroked-button type="button" class="btn-secondary" (click)="dialogRef.close(TipoArredondamentoEnum.Truncar)">Truncar</button>
    <button mat-flat-button type="button" class="btn-primary" (click)="dialogRef.close(TipoArredondamentoEnum.Arredondar)">Arredondar</button>
</mat-dialog-actions>
